import { request } from './core'
import type { Clarification, ClarifyListResponse } from './types'

type Ack = { ok: boolean; revision: number }

const answerBody = (answer: string, applyToField: boolean): RequestInit => ({
  method: 'POST',
  body: JSON.stringify({ answer, apply_to_field: applyToField }),
})

export const clarificationsApi = {
  // --- per-section ---

  triggerClarify: (slug: string, section: string) =>
    request<ClarifyListResponse & { revision: number }>(
      `/api/assessments/${slug}/sections/${section}/clarify`,
      { method: 'POST' },
    ),

  answerClarification: (slug: string, section: string, id: string, answer: string, applyToField = true) =>
    request<Ack>(
      `/api/assessments/${slug}/sections/${section}/clarifications/${id}/answer`,
      answerBody(answer, applyToField),
    ),

  skipClarification: (slug: string, section: string, id: string) =>
    request<Ack>(
      `/api/assessments/${slug}/sections/${section}/clarifications/${id}/skip`,
      { method: 'POST' },
    ),

  // --- overall (full-intake) loop ---

  triggerOverallClarify: (slug: string) =>
    request<{
      section: string
      cap: number
      decision: 'more_available' | 'complete' | 'cap_reached' | 'failed'
      questions: Clarification[]
      remaining_budget: number
      error?: string | null
    }>(`/api/assessments/${slug}/clarify/overall`, { method: 'POST' }),

  listOverallClarifications: (slug: string) =>
    request<{
      section: string
      cap: number
      status: string
      error?: string | null
      clarifications: Clarification[]
      pending_count: number
      remaining_budget: number
    }>(`/api/assessments/${slug}/clarify/overall`),

  answerOverallClarification: (slug: string, id: string, answer: string, applyToField = true) =>
    request<Ack>(`/api/assessments/${slug}/clarify/overall/${id}/answer`, answerBody(answer, applyToField)),

  skipOverallClarification: (slug: string, id: string) =>
    request<Ack>(`/api/assessments/${slug}/clarify/overall/${id}/skip`, { method: 'POST' }),
}
